const pixelPerMeter = 10;

export function metersToPixel(meters: number): number {
  return meters * pixelPerMeter;
}

export function pixelToMeters(pixel: number): number {
  return pixel / pixelPerMeter;
}